
export const createCustomerMutation = `
mutation RegisterCustomerForBooking($createCustomerInput: CreateCustomerInput!) {
  registerCustomerForBooking(createCustomerInput: $createCustomerInput) {
    id
    keycloakId
  }
}
`;
